import { FETCH_ADMIN_USER_ORDER_APPROVALS } from '../actions/types'

const initialState = {
  orders: [],
  totalCount: 0
}

const adminUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_USER_ORDER_APPROVALS:
      return { ...state, orders: action.payload }
    case 'SET_ADMIN_USER_TOTAL_ORDER_COUNT':
      return { ...state, totalCount: action.payload }
    default:
      return state
  }
}

export default adminUserReducer
